import { useFlag } from '@unleash/proxy-client-react'
import { ENABLE_ORDERING_REVAMP } from 'common/constants'
import React from 'react'

export const ThemeOverrides = () => {
  const orderingRevampEnabled = useFlag(ENABLE_ORDERING_REVAMP)

  if (!orderingRevampEnabled) return null

  return (
    <style>
      {`
      :root {
        --foreground-ui-navbar: #0D0D0D;
        --surface-ui-navbar: #fff;
      }
      `}
    </style>
  )
}
